<template>
  <div class="wrapper">
    <div class="main" v-if="!isLoading && !isOops">
      <div class="card">
        <img v-if="pixelRatio > 2 && res.component.headerPicX2Url" :src="res.component.headerPicX2Url" alt />
        <img v-else :src="res.component.headerPicUrl" alt />
      </div>
      <div class="cont">
        <p v-if="res.component.statusTxt" class="status" v-html="res.component.statusTxt"></p>
        <div v-if="res.showButton" :class="['btn-lottery', { 'btn-disable': disableBtn }]" @click="buttonClick">
          {{ res.component.buttonTxt }}
        </div>
        <div v-if="res.component.promotionDesc" class="rule-box" v-html="res.component.promotionDesc"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookie from 'js-cookie';
import { getMarketingPromotion, doLottery } from '../../service/getUser';

export default {
  name: 'activity',
  data() {
    return {
      res: {},
      token: '',
      deviceIdentifier: '',
      consumerKey: '',
      redeemCode: '', // 兑换码
      disableBtn: false, // 按钮是否置灰
      isLoading: true,
      isOops: false,
      pixelRatio: window.devicePixelRatio || 1,
    };
  },
  mounted() {
    if (window.PromotionBridge) {
      const params = JSON.parse(window.PromotionBridge.getParams());
      this.token = params.token;
      this.deviceIdentifier = params.deviceIdentifier;
      this.consumerKey = params.consumerKey;

      Cookie.set('auth', params.token);
      Cookie.set('deviceIdentifier', params.deviceIdentifier);
      Cookie.set('consumerKey', params.consumerKey);
    }

    this.initData(this.token, this.deviceIdentifier, this.$route.query.p);
  },
  methods: {
    /**
     * [getMarketingPromotion 初始化页面]
     */
    initData(token, deviceIdentifier, pid) {
      this.$loading.show();
      getMarketingPromotion(token, deviceIdentifier, pid).then(
        data => {
          this.res = data;
          this.redeemCode = data.code;

          const statusJson = {};
          statusJson.status = data.status;
          window.PromotionBridge && window.PromotionBridge.putActivityStatus(JSON.stringify(statusJson));

          // 活动结束置灰禁用按钮
          if (data.status === 4) {
            this.disableBtn = true;
          }
          // 数据跟新完毕
          this.isLoading = false;
          this.$loading.hide();
          // 主动触发GA tracking-click，间接统计pageview数据
          const { viewType, eventLabel } = data;
          this.$clickTracking({ eventCategory: 'perk_details', eventAction: viewType, eventLabel });
        },
        () => {
          this.isLoading = false;
          this.$loading.hide();
          this.isOops = true;
          this.$oops.show('页面错误，请返回重试。');
        },
      );
    },

    /**
     * [buttonClick 处理按钮Url、Click、Color各种状态]
     */
    buttonClick(e) {
      // GA tracking-click
      const { eventAction, eventLabel } = this.res;
      this.$clickTracking({ eventCategory: 'perk_details', eventAction, eventLabel });
      const {
        promotionType,
        status,
        code,
        component: { buttonUrl },
      } = this.res;
      // 处理按钮状态
      if (promotionType === 2 && status === 3) {
        // 点击抽奖
        this.toDoLottery();
      } else if (status === 5) {
        // 中奖-复制兑换码
        if (code) {
          this.copyRedeemCode();
        } else if (buttonUrl) {
          window.location.href = buttonUrl;
        }
      } else if (status === 4) {
        e.preventDefault();
      } else if (buttonUrl) {
        window.location.href = buttonUrl;
      }
    },
    /**
     * [toDoLottery 点击抽奖]
     */
    toDoLottery() {
      if ('onLine' in navigator) {
        if (navigator.onLine === false) {
          this.$toast.show('网络不好 请稍后再试');
          return;
        }
      }

      const timer = setTimeout(() => {
        this.$toast.show('请求超时 请稍后再试');
      }, 10000);

      const auth = Cookie.get('auth');
      const consumerKey = Cookie.get('consumerKey');
      const deviceIdentifier = Cookie.get('deviceIdentifier');
      doLottery(auth, consumerKey, deviceIdentifier, this.$route.query.p)
        .then(
          data => {
            clearTimeout(timer);
            this.res = Object.assign({}, this.res, data);
            this.redeemCode = data.code;
            const statusJson = {};
            statusJson.status = data.status;
            window.PromotionBridge && window.PromotionBridge.putActivityStatus(JSON.stringify(statusJson));
            // 主动触发GA tracking-click，间接统计pageview数据
            const { viewType, eventLabel } = data;
            this.$clickTracking({ eventCategory: 'perk_details', eventAction: viewType, eventLabel });
          },
          () => {
            clearTimeout(timer);
            this.isOops = true;
            this.$oops.show('网络错误');
          },
        )
        .catch(() => {
          clearTimeout(timer);
        });
    },
    /**
     * [copyRedeemCode 复制兑换码]
     */
    copyRedeemCode() {
      this.$copyText(this.redeemCode).then(() => {
        // 复制成功后跳转到使用说明页面
        if (this.res.component.buttonUrl) {
          window.location.href = this.res.component.buttonUrl;
        }
      });
    },
  },
  beforeDestroy() {
    Cookie.remove('auth');
    Cookie.remove('deviceIdentifier');
    Cookie.remove('consumerKey');
  },
};
</script>

<style lang="scss" scoped>
@import '../../assets/sass/mainpipe';

.main {
  position: absolute;
  display: table-cell;
  min-height: calc(100% - 0.36rem);
  margin: 0 0.35rem;
  border-radius: 0.06rem;
  background-color: #fff;
  border-bottom: 0.36rem solid $grey-bg;
  overflow: hidden;

  .card {
    position: relative;
    width: 6.8rem;
    margin: 0 auto;

    img {
      display: block;
      width: 6.8rem;
    }
  }

  .cont {
    width: 6.8rem;
    margin: 0 auto;
    font-family: PingFangSC-Medium;
    @include clearfix;

    .status {
      margin-top: 0.42rem;
      padding: 0 0.82rem;
      font-size: 0.32rem;
      color: #505050;
      letter-spacing: -0.0011rem;
      text-align: center;
    }

    .btn-lottery {
      display: block;
      margin: 0.4rem auto 0.44rem;
      width: 6rem;
      height: 0.96rem;
      border-radius: 0.6rem;
      line-height: 0.96rem;
      text-align: center;
      font-size: 0.36rem;
      letter-spacing: -0.003rem;
      text-decoration: none;
      color: #ffffff;
      background: #2dbe60;
    }

    .btn-disable {
      background-color: #dedede;
    }

    .rule-box {
      width: 5.76rem;
      margin: 0 auto 0.58rem;
      padding-bottom: 0.2rem;
    }
  }
}
</style>
